module.exports = __webpack_public_path__ + "img/calendar-check.c37cd28a.svg";